import {createContext} from 'react';
import type {BackendAPI} from '@/app/services/BackendAPI';
import type {WakeUpDetector} from '@/common/services/WakeUpDetector';

export const ServicesContext = createContext<{
	backendAPI: BackendAPI;
	wakeUpDetector?: WakeUpDetector;
} | null>(null);

ServicesContext.displayName = 'ServicesContext';
